import { generatePath } from 'react-router';
import history from '@AppRoutes/history';
import { paths } from '@AppRoutes/constants';
import MessageBroker from '@Services/MessageBroker';
import RequestUrls from '@Constants/RequestUrlsConstants';
import Login from '@Services/Login';
import AppStorage from '@Services/AppStorage';
import Auth from '@Services/Auth';
import { updateDialog } from '@Containers/Dialogs/DialogsActions';
import { typeOfRegisterConfirmationEmailSentDialog, typeOfRegisterConfirmationSuccessDialog } from './RegisterConfirmationConstants';
import { trackRegistrationErrors } from '../Register/analytics';

export const openConfirmationEmailSentDialog = ({ email }) => {
  return (dispatch) => {
    dispatch(
      updateDialog({
        id: typeOfRegisterConfirmationEmailSentDialog,
        dialogType: typeOfRegisterConfirmationEmailSentDialog,
        email,
      })
    );
  };
};

export const openConfirmationSuccessDialog = () => {
  return (dispatch) => {
    dispatch(
      updateDialog({
        id: typeOfRegisterConfirmationSuccessDialog,
        dialogType: typeOfRegisterConfirmationSuccessDialog,
      })
    );
  };
};

export const confirmationFromEmailLink = ({ regId, shibbolethToken }) => {
  return async (dispatch) => {
    try {
      await MessageBroker.send(RequestUrls.userRegisterConfirmationFromEmailLink, { regId });
      dispatch(openConfirmationSuccessDialog());

      if (Auth.getAccessToken()) {
        await Auth.logout();
      }

      let loginData;
      if (shibbolethToken) {
        const shibbolethInfo = AppStorage.instance.get('shibbolethInfo');
        loginData = {
          providerId: shibbolethInfo.providerId,
          shibbolethToken: shibbolethInfo.shibbolethToken,
          grant_type: 'shibboleth',
          registration_id: regId,
        };
        AppStorage.instance.remove('shibbolethInfo');

        await Auth.login(loginData);
      } else {
        await Auth.login({ registration_id: regId }, null, { grant_type: 'register' });
      }

      Login.afterAuthRedirect();
    } catch (error) {
      if (error.type !== 'CHOICE') {
        Logger.error(error);
        history.push({
          pathname: generatePath(paths.LOGIN),
        });
        setTimeout(() => trackRegistrationErrors([error.message], false), 1000); // call after redirect and AA init
      }
    }
  };
};
